import Username from "./Components/Username";
import Device from "./Components/Device";
import Size from "./Components/Size";
import Backup from "./Components/Backup";
import { exclusionDevicesUI } from "../Headers";
import useUIBp from "../../../../../../../../Hooks/useUIBoilerplate";
import BasicRow from "../../../../../../../UI/BasicLayout/Components/BasicRow";

// const rowData = {
//   id: "", // for select
//   disabled, // for select
//   elements: [{ xs, content: "ELEMENT" }],
// };
const fontSize = 13;

const DeviceRow = (props) => {
  const { settings } = useUIBp();
  const { mid } = props;

  const data = {
    id: mid,
    arrayId:exclusionDevicesUI,
    elements: [
      { content: <Username {...props} {...{ fontSize }} />, size: 3 },
      { content: <Device {...props} {...{ fontSize }} />, size: "grow" },
      { content: <Size {...props} {...{ fontSize }} />, size: 2 },
      { content: <Backup {...props} {...{ fontSize, settings }} />, size: 3 },
    ],
  };

  return <BasicRow {...data} />;
};

export default DeviceRow;
